<template>
    <el-dialog
        class="width-draw-form"
        :visible.sync="visible"
        :title="$t('Finance.Bank.money')"
        left>
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            :status-icon="true"
            label-position="right"
            label-width="90px"
            label-suffix=":">
            <el-form-item prop="money" :label="$t('Finance.money')">
                <el-input
                    v-model.number="form.money"
                    :placeholder="$t('Finance.fill_money')">
                </el-input>
            </el-form-item>
            <el-form-item prop="password" :label="$t('Staff.password')">
                <el-input
                    type="password"
                    v-model.trim="form.password"
                    :placeholder="$t('Common.fill_password')">
                </el-input>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button
                @click="confirm"
                type="primary"
            >{{ $t('Common.submit') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui';

export default {
    components: {
        ElDialog: Dialog,
    },
    data() {
        return {
            visible: false,
            form: {
                money: '',
                password: '',
            },
            rules: {
                money: { type: 'number', required: true, message: this.$t('Finance.fill_money') },
                password: { type: 'string', required: true, message: this.$t('Common.fill_password') },
            },
        };
    },
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
            }
        },
    },
    methods: {
        resetForm() {
            this.$refs.form.resetFields();
        },
        open() {
            this.visible = true;
        },
        confirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return false;
                this.visible = false;
            });
        },
    },
};
</script>

<style lang="scss">
.width-draw-form {
    .el-dialog {
        width: 430px;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .el-dialog--center .el-dialog__body {
        padding: 25px 25px 0;
    }
}
</style>
